import { render, staticRenderFns } from "./sessions-modal.vue?vue&type=template&id=4c13533c&"
import script from "./sessions-modal.vue?vue&type=script&lang=js&"
export * from "./sessions-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports